/**
 * Competition welcome tuning (specs/competitions-hub-client Slice 3D / 3G).
 *
 * Mirrors the World Cup welcome's timings so the two intros feel like the same
 * product. The WC screen keeps its own constants — this file never imports them,
 * so retuning one intro can never silently retune the other.
 */

/**
 * Above the competition shell chrome. `appStyles/_worldcup.styles.ts` puts the shell
 * header at `zIndex: 200` / `elevation: 200` so it survives web stacking contexts;
 * the intro is a full-screen takeover and must cover it.
 */
export const COMPETITION_WELCOME_ROOT_Z_INDEX = 10050;
export const COMPETITION_WELCOME_ROOT_ELEVATION = 32;

/** Skip sits above the phase body so it stays tappable over the hero art. */
export const COMPETITION_WELCOME_SKIP_Z_INDEX = COMPETITION_WELCOME_ROOT_Z_INDEX + 20;

export const COMPETITION_WELCOME_ANIM = {
  /** Overlay fade-out when entering the competition. */
  OVERLAY_EXIT_MS: 260,
  /** Crossfade between phases. */
  PHASE_CROSSFADE_MS: 260,
  /** Pulsing hero circles. */
  CIRCLE_BASE_DURATION_MS: 2600,
  CIRCLE_DURATION_STEP_MS: 420,
  CIRCLE_DELAY_STEP_MS: 220,
  /** Mascot bob. */
  MASCOT_BOB_MS: 2400,
} as const;

/** Concentric pulses behind the mascot. */
export const COMPETITION_WELCOME_CIRCLE_COUNT = 3;

/** Fixed block counts keep the stagger hook's work bounded. */
export const COMPETITION_WELCOME_RULES_BLOCK_COUNT = 8;
export const COMPETITION_WELCOME_POINTS_BLOCK_COUNT = 8;

export const COMPETITION_WELCOME_PHASES = ['splash', 'rules', 'points'] as const;
export type CompetitionWelcomePhase = (typeof COMPETITION_WELCOME_PHASES)[number];
export const COMPETITION_WELCOME_PHASE_LAST = COMPETITION_WELCOME_PHASES.length - 1;
